import * as React from "react";
import "../layout/layout.css";

interface Props {
  title: string;
  subtitle?: React.ReactNode;
  /** The chest beside the title, as on the app's Stash. Only on a phone; the sidebar has it wider. */
  logo?: boolean;
  actions?: React.ReactNode;
}

/** A page's big serif title, with a quiet line under it and its buttons on the right. */
export const PageHeader: React.FC<Props> = ({ title, subtitle, logo, actions }) => (
  <header className="page-header">
    {logo && <img className="page-header-logo only-phone" src="/logo.webp" alt="" />}
    <div>
      <h1 className="page-title">{title}</h1>
      {subtitle != null && <p className="page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="page-header-actions">{actions}</div>}
  </header>
);
